/**
 * TanStack Query key：物料可選單位（unit_options／unit aggregate）。
 * @param {string} mtrId
 * @returns {unknown[]}
 */
export function materialUnitOptionsQueryKey(mtrId) {
  return ['erp', 'materialUnit', 'options', mtrId];
}
